<div class="" *ngIf="mode==1">
    <label>Tipologia</label>
    <div class="input-group input-group-sm">
        <select class="form-control form-control-sm" [(ngModel)]="id_type" (change)="OnTypeChange($event)" >
            <option *ngFor="let t of list" [ngValue]="t.id">{{t.name}}</option>
        </select>
        <div *ngIf="showAll" class="input-group-append">
            <a class="btn btn-default" (click)="openModalListTypes()"><i class="fas fa-cog" title="Imposta tipologia" ></i></a>
        </div>
    </div>
</div>

<ng-container *ngIf="mode==2">
    <div class="input-group input-group-sm">
        <select class="form-control form-control-sm" [(ngModel)]="id_type" (change)="OnTypeChange($event)" >
            <option *ngFor="let t of list" [ngValue]="t.id">{{t.name}}</option>
        </select>
        <div *ngIf="showAll" class="input-group-append">
            <a class="btn btn-default" (click)="openModalListTypes()"><i class="fas fa-cog" title="Imposta tipologia" ></i></a>
        </div>
    </div>
</ng-container>


<ng-template #modalListTypes>
    <div class="modal-header">
        Tipologie
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeModalListTypes()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <ul class="list-group">
            <li  *ngFor="let t of list" class="list-group-item border-bottom px-0">
            <div class="row">
                <div class="col-8">
                    {{t.name}}
                </div>
                <div class="col-4">                    
                    <button class="btn btn-xs btn-danger ml-1 float-right" title="Elimina" (click)="removeType(t)"><i class="fa fa-trash"></i></button>
                    <button class="btn btn-xs btn-secondary ml-1 float-right" title="Modifica" (click)="editType(t)"><i class="fa fa-pencil-alt"></i></button>
                </div>
            </div>
            </li>
        </ul>
        <button class="btn btn-outline-success btn-block mt-2" (click)="addType()"><i class="fas fa-plus mr-2"></i>Aggiungi</button>
        <button class="btn btn-secondary btn-block mt-2" (click)="closeModalListTypes()"><i class="fas fa-times mr-2"></i>Chiudi</button>
    </div>
</ng-template>